import { ClosingCta } from "@frontend/components/site/closing-cta";
import { HowItWorks } from "@frontend/components/site/how-it-works";
import { branding } from "@creators/backend/lib/config";
import { Seo } from "@frontend/lib/seo";
import { useViewer } from "@frontend/lib/viewer";

const DESCRIPTION =
  "From a link in your bio to money in your account: claim your page, take offers, counter until the terms fit, and get paid by stage.";

export function HowItWorksPage() {
  const { viewer } = useViewer();
  const signedIn = Boolean(viewer && !viewer.isAdmin);
  const host = branding.domain;

  return (
    <main>
      <Seo
        title={`How it works — ${branding.name}`}
        description={DESCRIPTION}
        path="/how-it-works"
      />
      <HowItWorks host={host} />
      <ClosingCta signedIn={signedIn} />
    </main>
  );
}
